import { render, staticRenderFns } from "./SchoolInterstitial.vue?vue&type=template&id=37a77fc5&scoped=true&"
import script from "./SchoolInterstitial.vue?vue&type=script&lang=js&"
export * from "./SchoolInterstitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a77fc5",
  null
  
)

export default component.exports